import React from 'react';
import { Flexbox } from '../action/Flexbox';
import ThemedText from '../theme/ThemedText';
import './DualProgressbar.scss';

const DualProgressBar = ({ leftValue, rightValue, rightContent, leftContent, leftLabel = '', rightLabel = '', className = '', gradientColors = ['#98E56C', '#FF5858'] }) => {
  const total = Number(leftValue || 0) + Number(rightValue || 0);
  const leftRatio = total > 0 ? leftValue / total : 0.5;

  return (
    <Flexbox className={`dualprogress_container ${className}`} fw justifyContent='flex-start'>
      <Flexbox gap='0.25rem' className='dualprogress_container_valuelabel' justifyContent='flex-start'>
        <ThemedText.H6>{leftContent}</ThemedText.H6>
        <ThemedText.H6 color='color-xlight'>{leftLabel}</ThemedText.H6>
      </Flexbox>

      <div
        className='dualprogress_container_bar'
        style={{
          background: `linear-gradient(to right, ${gradientColors[0]}, ${gradientColors[1]})`,
        }}
      >
        <div className='dualprogress_container_indicator' style={{ right: `calc(${leftRatio * 100}% - 1px)` }} />
      </div>

      <Flexbox gap='0.25rem' className='dualprogress_container_valuelabel' justifyContent='flex-end'>
        <ThemedText.H6>{rightContent}</ThemedText.H6>
        <ThemedText.H6 color='color-xlight'>{rightLabel}</ThemedText.H6>
      </Flexbox>
    </Flexbox>
  );
};

export default DualProgressBar;
